import { useAtomValue } from 'jotai'
import React from 'react'

import { type Brand } from '~/hooks/useSurveyQuery'
import { type NineSegment, toNineNumber } from '~/utils'

import { lastTabulatedVariablesAtom } from '../atoms'

export const useGetBrandNineSegmentIndex = () => {
  const lastTabulatedVariables = useAtomValue(lastTabulatedVariablesAtom)

  return React.useCallback(
    (brand: Brand, nineSegment: NineSegment) => {
      const groupFilters_ = lastTabulatedVariables?.question.groupFilters
      const groupFilters = Array.isArray(groupFilters_) ? groupFilters_ : []

      return groupFilters.findIndex(
        ({ group }) => group === [brand.id, toNineNumber(nineSegment)].join(),
      )
    },
    [lastTabulatedVariables?.question.groupFilters],
  )
}
